import {useState} from 'react';
import Loginbonus from "./Loginbonus";
import DarkStoreItem from "./DarkStoreItem";
import Recharge from "./Recharge";
import config from "../config";
import CobBucks from "./CobBucks"

function DarkStarGamepage(initialView) {
    const [view, setView] = useState(initialView);
    //const [consecutiveDays, setConsecutiveDays] = useState(0);
    const handleClick=(e)=>setView(e.target.id);
    //const incrementConsecutiveDays=(e)=>{
        //handle case where consecutive days = 7
       // setConsecutiveDays(consecutiveDays+1);
       // setView('game');
    //}
    const progressWidth=()=>{
        var days = localStorage.getItem("consecutiveDays")
        if (days === null){
            return 0 + '%'
        }
        else {
            return (days/7)*100 + '%'
        }
    }
    let CobEls = [];
    for (let mybucks of config.CobBucks) {
      CobEls.push(
        <CobBucks
          name={mybucks.name}
          price={mybucks.price}
          image={mybucks.image}
          id={mybucks.id}
        />
      );
    }
    
    return(
        <div className="homepage-bgimage">  
            <div className="buttons">
                <button id='game' type="button" onClick={handleClick}>
                    Game
                </button>
                <button id='loginbonus' type="button" onClick={handleClick}>
                    Login Bonus
                </button>
                <button id='store' type="button" onClick={handleClick}>
                    Store
                </button>
                <button id='recharge' type="button" onClick={handleClick}>
                    Recharge
                </button>
            </div>
            
            {
                view === 'game' ?
                (<iframe title='game'
                    src="https://tundeszirak.github.io/hangman/" 
                style={{width: '70%', height: '70%'}}>
                    
                </iframe>) :
                view === 'loginbonus' ?
                
                <Loginbonus  />
                
                 :

                view === 'store' ?
                <DarkStoreItem />
                :
                <Recharge />
                
            }
            
            <div className="Bucks">
                {CobEls}
            </div>
                <span></span>
                <span>Login Bonus</span>
                <div className="progress">
                    <div className="progress-bar" role="progressbar" 
                    style={{width: progressWidth()}} aria-valuenow="25" aria-valuemin="0" 
                    aria-valuemax="100"></div>
                </div>
                <span>Login 7 days to unlock dark mode!</span>
        </div>
    );
}

export default DarkStarGamepage;